/* import __COLOCATED_TEMPLATE__ from './unique-view-counter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import ViewConfig from 'embercom/lib/reporting/flexible/view-config';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import { CARDINALITY } from 'embercom/lib/reporting/flexible/constants';
import { articleViewsDataConfig } from 'embercom/lib/reporting/flexible/articles';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';
import { inject as service } from '@ember/service';

const seriesName = 'help_center_views_unique';

export default class ArticlesUniqueViewCounter extends Component {
  @service intl;

  get viewConfig() {
    let viewConfig = new ViewConfig();

    viewConfig.formatUnit = { unit: units.value };
    viewConfig.aggregations = { defaultOption: CARDINALITY };
    viewConfig.groupings = {
      defaultOption: {
        value: 'event.created_at',
        text: 'Time',
        type: 'temporal',
        isComparison: true,
        createTitleTooltipText: () => {
          return this.intl.t('articles.reports.unique-view.tooltip');
        },
      },
    };
    viewConfig.counter = {
      [seriesName]: {
        improvementDirection: improvementDirections.INCREASING,
      },
    };

    return viewConfig;
  }

  get dataConfig() {
    return {
      series: [
        {
          name: seriesName,
          type: CARDINALITY,
          data: { property: 'user.id' },
          ...articleViewsDataConfig(),
        },
      ],
    };
  }
}
